import { render, staticRenderFns } from "./cement-fluid.vue?vue&type=template&id=2be32501&scoped=true"
import script from "./cement-fluid.vue?vue&type=script&lang=js"
export * from "./cement-fluid.vue?vue&type=script&lang=js"
import style0 from "./cement-fluid.vue?vue&type=style&index=0&id=2be32501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be32501",
  null
  
)

export default component.exports